// Frames polaris's account pages (login, password reset, invitation, …) in the
// Oktober look: a tall glass card over a blurred, glowing oxblood backdrop,
// the logo inside the card's warm "sky". The pages keep their markup;
// .om-auth in styles/oktober.css re-skins their wrapper and card.
import { useLayoutEffect, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { setMarkOnScreen } from './splashMark';

export function AuthShell({ children }: { children: ReactNode }) {
  const { t } = useTranslation();

  // This page replaces the loading mark, so after signing in the splash plays
  // its entrance rather than starting as if the mark were still showing.
  useLayoutEffect(() => {
    setMarkOnScreen(false);
  }, []);

  return (
    <div className="om-auth">
      {/* The blurred "site behind the card": glows and the giant wordmark */}
      <div className="om-auth-backdrop" aria-hidden>
        <span className="om-auth-glow" style={{ left: '8%', top: '6%', width: '46vw', height: '40vw' }} />
        <span className="om-auth-glow" style={{ right: '4%', bottom: '2%', width: '40vw', height: '34vw', opacity: 0.55 }} />
        <span className="om-auth-glow" data-deep style={{ left: '38%', top: '30%', width: '34vw', height: '30vw' }} />
        <span className="om-auth-wordmark" />
      </div>
      <div className="om-auth-body om-pop-in">
        <div style={{ position: 'relative', width: '100%' }}>{children}</div>
      </div>
      <footer className="om-auth-tagline">
        {t('oktober.auth.copyright', '© {{year}} Oktober. All rights reserved.', { year: new Date().getFullYear() })}
      </footer>
    </div>
  );
}
